<!-- <div class="innerBanner" style="background-image: url('{{ privacyDetails.bannerImage }}')"> -->
<!-- <img
      [src]="privacyDetails.bannerImage ? privacyDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
      style="width: 100%"
    /> -->
<!-- <div class="bannerText"></div>
</div> -->

<div class="innerBanner" [style.background-image]="'url(' + bannerImage + ')'" (click)="imageClick(0)"></div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"></li>
    </ol>
  </nav>
  <!-- <h1>{{ privacyDetails.bannerTitle }}</h1> -->
  <div class="pageTitle" style="margin-bottom: 30px">
    <div class="privacyPolicy" #privacyPolicy>
      <div class="container" *ngIf="status === '200'">
        <div [innerHTML]="msg"></div>
        <a routerLink="/reset-password">Change Password</a>
      </div>
      <div class="container" *ngIf="status != '200'">
        <div [innerHTML]="msg"></div>
      </div>
    </div>
  </div>
</div>
